import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cabinet-settings mt-4" }
const _hoisted_2 = { class: "mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_settings_list_item = _resolveComponent("settings-list-item")!
  const _component_list = _resolveComponent("list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_page_title, { title: "Настройки" }),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.state.is_failed && !_ctx.state.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.state.is_loading,
            text: "При получении списка настроек кабинета произошла ошибка",
            "error-message": _ctx.state.failure.error_state.message,
            "error-url": _ctx.state.failure.error_state.url,
            "error-status": _ctx.state.failure.error_state.status,
            onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadSettings(_ctx.state.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_openBlock(), _createBlock(_component_list, {
            key: 1,
            loading: _ctx.state.is_loading,
            items: _ctx.state.list,
            pagination: "",
            "pagination-current-page": _ctx.state.pagination.current_page,
            "pagination-total-pages": _ctx.state.pagination.total_pages,
            onChangePage: _ctx.loadSettings
          }, {
            item: _withCtx(({ item }) => [
              _createVNode(_component_settings_list_item, {
                item: item,
                onEnabled: _ctx.onSettingEnabled,
                onDisabled: _ctx.onSettingDisabled
              }, null, 8, ["item", "onEnabled", "onDisabled"])
            ]),
            _: 1
          }, 8, ["loading", "items", "pagination-current-page", "pagination-total-pages", "onChangePage"]))
    ])
  ]))
}